import { Component, Input } from '@angular/core';

@Component({
  selector: 'market-sectors-popover',
  template: `
    <div class="p-5 flex flex-wrap gap-2">
      <div *ngFor="let sector of marketSectors" class="chip items-center">
        <img [src]="sector?.icon" alt="{{ sector.name }}" class="icon" />
        <span>{{ sector.name }}</span>
      </div>
    </div>
  `,
  styles: [
    `
      .chip {
        display: inline-flex;
        padding: 8px 12px;
        background-color: white;
        border-radius: 16px;
        border: 2px solid #e0e0e0;
        font-size: 14px;
        font-weight: 500;
        color: #333;
      }

      .icon {
        width: 20px;
        height: 20px;
        margin-right: 8px;
        // object-fit: cover;
      }
    `,
  ],
})
export class MarketSectorsPopoverComponent {
  @Input() marketSectors: any[] = [];
}
